import {
  PROPERTY_ERROR,
  ADD_PROPERTY,
  PROPERTY_LIST,
  PROPERTY_FORM,
  PROPERTY_EDIT,
  PROPERTY_FORM_UPDATE,
  PROPERTY_FILTER_LIST,
  GETPROPERTY_DETAIL,
  PROPERTY_STATUS_UPDATE,
  PROPERTY_CHECK,
} from "reduxStore/types";
import propertyService from "reduxStore/service/propertyService";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError, greMobileOtpSettingToast } from "utils/httpClient";
import {
  PROPERTY_CONFIGURATION_LIST,
  PROPERTY_DOCUMENT_DELETE,
  SYNC_ALL_PROJECTS,
} from "../types";

export const propertyForm = (item) => async (dispatch) => {
  try {
    dispatch({
      type: PROPERTY_FORM,
      payload: item,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const propertyFormUpdate = (item) => async (dispatch) => {
  try {
    dispatch({
      type: PROPERTY_FORM_UPDATE,
      payload: item,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getAllProperty = (item) => async (dispatch) => {
  try {
    const res = await propertyService.getAllProperty(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROPERTY_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const getAgentProperty = (item) => async (dispatch) => {
  try {
    const res = await propertyService.getAgentProperty(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROPERTY_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const addProperty = (item) => async (dispatch) => {
  try {
    const res = await propertyService.addProperty(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_PROPERTY,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const editProperty = (item) => async (dispatch) => {
  try {
    const res = await propertyService.editProperty(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_EDIT,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const getPropertyDetail = (item) => async (dispatch) => {
  try {
    const res = await propertyService.getPropertyDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: GETPROPERTY_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const getPropertyFilterList = (item) => async (dispatch) => {
  try {
    const res = await propertyService.getPropertyFilterDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_FILTER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROPERTY_FILTER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const propertyStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await propertyService.propertyStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_STATUS_UPDATE,
        payload: res.data,
      });
      successToast(res.data.message);
      return true;
    }
    errorToast(res.data.message);
    return false;
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
    return false;
  }
};

export const propertyGreMobileOtpUpdate = (item) => async () => {
  try {
    const res = await propertyService.propertyGreMobileOtpUpdate(item);
    if (res.data.status === 200) {
      greMobileOtpSettingToast(
        Boolean(item.gre_mobile_otp_enabled),
        item.property_title,
      );
      return true;
    }
    errorToast(res.data.message, {
      title: strings.greMobileOtpUpdateFailedTitle,
    });
    return false;
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response?.data?.message || response.data.message, {
      title: strings.greMobileOtpUpdateFailedTitle,
    });
    return false;
  }
};

export const propertyGreBannerUpdate = (item) => async () => {
  // Redux thunk for super admin GRE banner upload/replace.
  try {
    const res = await propertyService.propertyGreBannerUpdate(item);
    if (res.data.status === 200) {
      successToast(res.data.message, { title: strings.greBannerUpdatedTitle });
      return res.data;
    }
    errorToast(res.data.message, {
      title: strings.greBannerUpdateFailedTitle,
    });
    return false;
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response?.data?.message || response.data.message, {
      title: strings.greBannerUpdateFailedTitle,
    });
    return false;
  }
};

export const propertyGreBannerRemove = (item) => async () => {
  // Redux thunk for super admin GRE banner remove.
  try {
    const res = await propertyService.propertyGreBannerRemove(item);
    if (res.data.status === 200) {
      successToast(res.data.message, { title: strings.greBannerRemovedTitle });
      return true;
    }
    errorToast(res.data.message, {
      title: strings.greBannerUpdateFailedTitle,
    });
    return false;
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response?.data?.message || response.data.message, {
      title: strings.greBannerUpdateFailedTitle,
    });
    return false;
  }
};

export const getConfigurationPropList = (item) => async (dispatch) => {
  try {
    const res = await propertyService.getConfigurationPropList(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_CONFIGURATION_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROPERTY_CONFIGURATION_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};

export const propertyDocumentDelete = (item) => async (dispatch) => {
  try {
    const res = await propertyService.propertyDocumentDelete(item);
    if (res.data.status === 200) {
      dispatch({
        type: PROPERTY_DOCUMENT_DELETE,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const propertyCheckAction = (item) => async (dispatch) => {
  try {
    const res = await propertyService.propertyCheck(item);
    dispatch({
      type: PROPERTY_CHECK,
      payload: res.data,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const continueSameProperty = (item) => async (dispatch) => {
  try {
    dispatch({
      type: PROPERTY_CHECK,
      payload: null,
    });
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};

export const syncAllProjects = (item) => async (dispatch) => {
  try {
    const res = await propertyService.syncAllProjects(item);
    if (res.data.status === 200) {
      dispatch({
        type: SYNC_ALL_PROJECTS,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
